export const Action = {
	LOAD_VALIDATION_MESSAGE: 'LOAD_VALIDATION_MESSAGE',
  };

export const Mutation = {
	SET_ALLOWED_CHARS: 'SET_ALLOWED_CHARS',
	SET_VALIDATION_MESSAGE: 'SET_VALIDATION_MESSAGE',
	SET_FORM_SUBMITTED: 'SET_FORM_SUBMITTED',
};
